<!--
 * @Author: 范向玲
 * @Date: 2022-12-06 15:39:08
 * @LastEditTime: 2024-12-23 16:26:23
 * @LastEditors: chenmengnan chenmengnan@piesat.cn
 * @Description: 走势库数据管理--详情表格
 * @FilePath: \web\src\components\DataManagement\reservesLibrary\component\sort.vue
-->
<template>
  <section class="trend-detail-container">
    <a-table rowKey="id" class="trend-detail-table" :dataSource="sortPages" :loading="trendDetailPagesLoading"
      :columns="detailColumns" @change="detailChangePage" :scroll="{ y: '96%' }" :pagination="false">
      <template #serial="{ index }">{{ index + 1 }}</template>
      <template #action="{ record, index }">
        <section class="action-icons">
          <i v-for="(item, i) in detailTableOperationList" :key="i" v-bind="item.option" :style="{
            color:
              (item.option.title === '上移' && index <= 0) ||
                (item.option.title === '下移' && index === sortPages.length - 1)
                ? 'rgba(255, 200, 120, 0.6)'
                : 'rgb(255, 200, 120)',
          }" @click="item.click(record, index)">
          </i>
        </section>
      </template>
    </a-table>
  </section>
</template>

<script setup>
import { message } from 'ant-design-vue';
import { useStore, defineEmits } from 'vuex';
import { ref, reactive, computed, toRefs, watch, onMounted, onBeforeMount, defineProps } from 'vue';
// import { sortTableConfig } from './../manager/tableConfig.js';
import { sortTableConfig } from './../manage/tableConfig';
import { GET_MINERAL_DATA_PAGE } from '@/store/modules/actions/trendDataManager.js';
import { removePriceDataApi, priceDatasEditApi } from '@/api/projectPerformance/dataManager.js';
import { getSortListApi, setSortNewListApi } from '@/api/projectPerformance/reserves';
import config from '@/config/config';
import Modal from '@/components/lib/Modal/modal1.vue';
import moment from 'moment';

const props = defineProps({
  headerInfo: {
    type: Array,
  },
  code: {
    type: String,
  },
});
const emit = defineEmits(['setSort',]);
const detailColumns = sortTableConfig;

const { state, dispatch: storeDispatch, commit: storeCommit } = useStore();
// state
const trendDataManagerState = computed(() => state.trendDataManager);
const { detailTotalCount, detailRequestParams, trendDetailPagesLoading } = toRefs(
  trendDataManagerState.value,
);
// 重写commit
const commit = (space, methods, params) => storeCommit(`${space || 'trendDataManager'}/${methods}`, params);
// 重写dispatch
const dispatch = (space, methods, params) => storeDispatch(`${space || 'trendDataManager'}/${methods}`, params);
const sortPages = ref([]);
const isCrudEdit = ref(true); // 编辑、确认按钮状态

// 确认弹窗 公用
const confirmModalConf = reactive({
  loading: false,
  visible: false,
  title: '',
  confirm: null,
  remark: '',
  callback: null,
  showRemark: true,
  showUpload: false,
  selectValue: [],
});

const selectedKeys = ref([]); // 表格选中id

/* 查询 */
const detailSearchHandle = () => {
  getSortListApi({ type: props.code })
    .then((res) => {
      if (res.code === 200) {
        sortPages.value = res.data;
      }
    })
    .catch(() => { });
};
// 数据上移
const upRecord = (record, index) => {
  if (index <= 0) {
    console.log('已经是第一条了');
  } else {
    let updata = sortPages.value[index - 1];

    sortPages.value.splice(index - 1, 1);
    sortPages.value.splice(index, 0, updata);
    emit('setSort', { arr: sortPages.value })
  }
};
// 数据下移
const downRecord = (record, index) => {
  if (index === sortPages.value.length - 1) {
    console.log('已经是最后一条了');
  } else {
    let downdata = sortPages.value[index + 1];

    sortPages.value.splice(index + 1, 1);
    sortPages.value.splice(index, 0, downdata);
    console.log(sortPages.value)
    emit('setSort', { arr: sortPages.value })
  }
};
const detailTableOperationList = ref([]);

const detailTableOperationListConf = [
  {
    option: {
      style: 'color: rgb(255, 200, 120)',
      class: 'iconfont icon-jiantou_xiangshang',
      title: '上移',
    },
    click: upRecord,
    operation: [1, 2],
  },
  {
    option: {
      style: 'color: rgb(255, 200, 120)',
      class: 'iconfont icon-jiantou_xiangxia',
      title: '下移',
    },
    click: downRecord,
    operation: [1, 2],
  },
];

// 详情页页码change事件
const detailChangePage = (page) => {
  // commit(null, 'setDetailRequestParams', { page: page.current, size: page.pageSize });
  // detailSearchHandle();
};

onBeforeMount(() => {
  detailTableOperationList.value = detailTableOperationListConf.filter((i) =>
    i.operation.includes(config.getPermissionId()),
  );
  detailSearchHandle();
});
</script>

<style lang="scss">
.trend-detail-container {
  .detail-header {
    margin: 0.1rem;
    display: flex;
    justify-content: space-between;

    .detail-infotext {
      border-left: .04rem solid #f3a708;
      // width: 6.5rem;
      background-color: rgba(140, 100, 30, 0.2);
      display: flex;

      .detail-infotext-item {
        display: flex;
        margin: 0 0.05rem;

        .detail-infotext-label {
          color: rgba(255, 195, 76, 1);
        }
      }
    }

    .crud-wrapper {
      display: flex;

      // height: 0.51rem;
      // padding: 0.13rem 0.1rem;
      .crud-item {
        margin-right: 0.04rem;
        width: 0.5rem;
        color: #fff;
        // background-color: #efb227;
        background-image: url(~@/static/images/dataManagement/curd_btn.png);
        background-size: 100% 100%;
        text-align: center;
      }

      .crud-item:hover {
        cursor: pointer;
      }

      .crud-item-disabled {
        pointer-events: none;
        color: rgba(255, 255, 255, 0.6);
        // background-color: rgba(239, 178, 39, 0.6);
        opacity: 0.8;
      }

      .crud-item-disabled:hover {
        cursor: no-drop;
      }
    }
  }

  /* 表格样式修改 */
  .trend-detail-table {
    height: calc(100% - 0.84rem);

    .ant-spin-container {
      display: flex;
      flex-direction: column;
      align-items: end;
    }

    .ant-spin-nested-loading,
    .ant-spin-container,
    .ant-table-content {
      height: 100%;
    }

    .ant-table {
      height: calc(100% - .70rem);
      background: none;
      padding-left: 0.1rem;

      .ant-table-scroll {
        height: 100%;
        overflow: visible;
        overflow-x: visible;

        .ant-table-header {
          overflow: visible !important;
        }
      }

      .ant-table-header {
        background: none;
      }

      .ant-table-body {
        overflow-x: hidden !important;
        overflow-y: auto !important;
        background: none;
      }

      /* 矿种 */
      .primary-commodity-img {
        width: 0.8rem;
        height: 0.6rem;
      }

      /* 图标 */
      .action-icons {
        i {
          font-size: 0.22rem;
          margin-right: 0.04rem;
          cursor: pointer;
        }
      }

      .ant-table-thead {
        border: .01rem solid #4d3f1c;
        border-radius: .10rem .10rem 0rem 0rem;
        background: none;
      }

      .ant-table-thead>tr>th {
        color: #ffc44d;
        background: rgba(179, 150, 92, 0.2);
        border: none;
      }

      .ant-table-tbody>tr>td {
        background-color: transparent;
        color: #fff;
        border-bottom: .01rem solid rgba(179, 150, 92, 1);
        vertical-align: middle;
      }

      .ant-table-placeholder {
        height: 100%;
        background-color: rgba(77, 63, 28, 1);
        border-top: rgba(179, 150, 92, 1);
        border-bottom: rgba(179, 150, 92, 1);
      }

      .ant-empty-normal {
        color: rgba(179, 150, 92, 1);
      }

      // 暂无数据填充样式
      // .ant-empty-img-simple-path {
      //   fill: rgba(77, 63, 28, 1);
      // }
      // .ant-empty-img-simple-ellipse {
      //   fill: rgba(77, 63, 28, 1);
      // }
      .ant-table-thead>tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td,
      .ant-table-tbody>tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td,
      .ant-table-thead>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td,
      .ant-table-tbody>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td {
        background-color: rgba(179, 150, 92, 0.6);
      }

      .ant-table-thead>tr:hover.ant-table-row-selected>td,
      .ant-table-tbody>tr:hover.ant-table-row-selected>td {
        background-color: rgba(179, 150, 92, 0.6);
      }

      .ant-table-tbody>tr.ant-table-row-selected td {
        background-color: rgba(77, 63, 28, 1);
        color: #fff;
      }
    }
  }
}
</style>
